function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M5.376 0.192q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.856 1.056-3.584t2.336-3.936 1.6-4.96q0.064-0.128 0.224-0.128t0.16 0.128zM25.088 0.192q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.536 0.672-2.976t1.536-2.496 1.696-2.944 1.088-4.064q0.064-0.128 0.224-0.128t0.16 0.128zM14.848 14.4q0.064-0.128 0.224-0.128t0.16 0.128q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.856 1.056-3.584t2.336-3.936 1.6-4.96z"
});

var SvgWater = function SvgWater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-water",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water.70e41f12.svg";
export { ForwardRef as ReactComponent };